import { createContext } from "react";

/**
 * True for anything rendered inside a modal dialog. Controls that open a popup of their own
 * (such as the date picker) use it to render that popup inside the dialog, where the modal's
 * focus trap allows focus.
 */
export const InModalContext = createContext(false);
